
<main>
    <div class="profile-details">
        <div class="profile-form">
            <form [formGroup]="notificationForm" (ngSubmit)="submit()">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="શીર્ષક" formControlName="notification_title" />
                    <div *ngIf="submitted && f.notification_title.errors" class="error-message">
                        <small *ngIf="f.notification_title.errors?.required" class="text-danger">શીર્ષક
                            જરૂરી
                            છે.</small>
                    </div>
                </div>
                <div class="form-group">
                    <textarea class="form-control" placeholder="વર્ણન" formControlName="description"></textarea>
                    <div *ngIf="submitted && f.description.errors" class="error-message">
                        <small *ngIf="f.description.errors?.required" class="text-danger">વર્ણન જરૂરી
                            છે.</small>
                    </div>
                </div>
                <div class="form-group">
                    <select class="form-control" formControlName="userSelect">
                        <option hidden value="" disabled selected>કમિટી પસંદ કરો.</option>
                        <option *ngFor="let option of userSelectOptions" [value]="option.user_type_id">{{
                            option.user_type }}
                        </option>
                    </select>
                    <div *ngIf="submitted && f.userSelect.errors" class="error-message">
                        <small *ngIf="f.userSelect.errors?.required" class="text-danger">કમિટી જરૂરી છે.</small>
                    </div>
                </div>

                <!-- Multi select code -->
                <!-- <div class="form-group">
                    <mat-form-field appearance="fill">
                      <mat-label>કમિટી પસંદ કરો.</mat-label>
                      <mat-select formControlName="userSelect" multiple>
                        <mat-option *ngFor="let option of userSelectOptions" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="submitted && f.userSelect.errors" class="error-message">
                      <small *ngIf="f.userSelect.errors?.required" class="text-danger">userSelect જરૂરી છે.</small>
                    </div>
                  </div> -->
                <div class="form-group">
                    <button type="submit" class="btn-common">નોંધણી કરો</button>
                </div>
            </form>
        </div>
    </div>
</main>